import React from 'react';
import ExcelJS from 'exceljs';
import {Button} from "@deere/ux.uxframe-react";
import {useSelector} from "react-redux";

import {pipList} from "../pip-search/pipSearchSlice";
import {claimList} from "../claim-search/claimSearchSlice";
import {customerHistory} from "../customer-search/customerHistorySlice";
import {productComponents, productOptions} from "../product-config/productConfigSlice";
import {warrantyList} from "../warranty-search/warrantySearchSlice";
import {format, parseISO} from "date-fns";
import {languageResponseData} from "../Translation/translationSerachSlice";

const ExportMachineDetails = ({machineDetails}) => {
    const translationsResponse = useSelector(languageResponseData);
    const translate = (key, defaultText) => {
        return translationsResponse[key] || defaultText;
    };

    const warrantyData = useSelector(warrantyList);
    const csnData = useSelector(productComponents);
    const optionCodeData = useSelector(productOptions);
    let custHistoryData = useSelector(customerHistory);
    const claimsData = useSelector(claimList);
    const pipsData = useSelector(pipList);
    /*console.log("Machine Details: ", machineDetails);*/

    if (!Array.isArray(custHistoryData)) {
        custHistoryData = [];
    }

    const formatDateForExport = (date) => {
        if (date) {
            const parsedDate = parseISO(date);
            return format(parsedDate, 'dd MMM yyyy');
        } else {
            // Handle the case where date is undefined or null
            return 'N/A'; // Or any other default value you prefer
        }
    }

    const handleMachineDetailExport = async () => {

        // Create a new Excel workbook
        const workbook = new ExcelJS.Workbook();

        // Add a worksheet for the machine details
        const machineDetailsSheet = workbook.addWorksheet('Machine Details');

        // Fetch Customer Name from the first Customer in the Customer History Data


        /*const activeCustomer = custHistoryData[0];
        let customerName = "N/A"
        if (activeCustomer && activeCustomer.activeCustomer && activeCustomer.customer.customerType === "Business"){
            customerName = activeCustomer.customer?.businessName1?.trim() || activeCustomer.customer?.businessName2?.trim()
        } else if (activeCustomer && activeCustomer.activeCustomer && activeCustomer.customer.customerType === "Individual"){
            customerName = [activeCustomer.customer?.firstName, activeCustomer.customer?.middleName, activeCustomer.customer?.lastName].map(name => name?.trim()).filter(Boolean).join(" ");
        }*/

        // Mapping the active customer from the customer history list to a customer object to display customer data in Machine Details section
        const activeCustomerData = custHistoryData.filter(customer => customer?.activeCustomer).map(
            (customerData) => {
                const customer = customerData?.customer;
                let customerName = "N/A"

                if (customerData && customerData.activeCustomer && customer?.customerType === "BUSINESS") {
                    customerName = customer?.businessName1?.trim() || customer?.businessName2?.trim()
                } else if (customerData && customerData.activeCustomer && customer.customerType === "INDIVIDUAL") {
                    customerName = [customer?.firstName, customer?.middleName, customer?.lastName].map(name => name?.trim()).filter(Boolean).join(" ");
                }
                return {
                    customerName: customerName,
                    entityId: customer?.entityId + "",
                    city: customer?.addresses[0]?.city,
                    stateCode: customer?.addresses[0]?.state,
                    countryCode: customer?.addresses[0]?.country,
                    postalCode: customer?.addresses[0]?.postalCode,
                    street: customer?.addresses[0]?.street,
                    street2: customer?.addresses[0]?.city + " " + customer?.addresses[0]?.state + " " + customer?.addresses[0]?.country + " " + customer?.addresses[0]?.postalCode,
                    homePhone: (customer?.homePhone?.countryCode || "") + (customer?.homePhone?.areaCode || "") + (customer?.homePhone?.phoneNumber || "") || "N/A",
                    cellPhone: (customer?.mobilePhone?.countryCode || "") + (customer?.mobilePhone?.areaCode || "") + (customer?.mobilePhone?.phoneNumber || "") || "N/A",
                    businessPhone: (customer?.workPhone?.countryCode || "") + (customer?.workPhone?.areaCode || "") + (customer?.workPhone?.phoneNumber || "") || "N/A",
                    customerNumber: customer?.entityId + "",
                    purchaseType: customerData.purchaseType,
                    endUseCode: customerData.endUseCodeDesc,
                    deliveryDate: customerData.deliveryReceiptDate,
                    sellingDealer: customerData.sellingDealer,
                    responsibleDealer: customerData.responsibleDealer
                }
            }
        )[0];

        // Define the machine details data
        const machineDetailsData = [
            ['PIN', machineDetails?.pinNumber17 || machineDetails?.ntvPin || machineDetails?.pinNumber13],
            [''],//empty rowd
            [activeCustomerData?.customerName],
            [activeCustomerData?.street ],
            [activeCustomerData?.street2 ],
            [''],
            ['Home', activeCustomerData?.homePhone || "N/A"],
            ['Cell', activeCustomerData?.cellPhone || "N/A"],
            ['Business', activeCustomerData?.businessPhone || "N/A"],
            ['Customer Number', activeCustomerData?.entityId],
            ['Purchase Type', activeCustomerData?.purchaseType],
            ['End Use Code', activeCustomerData?.endUseCode],
            ['Delivery Date', formatDateForExport(activeCustomerData?.deliveryDate)],
            ['Settlement Date', formatDateForExport(machineDetails?.settlementDate)],
            ['Invoice Date', formatDateForExport(machineDetails?.dealerInvoiceDate)],
            ['Registration Date', formatDateForExport(machineDetails?.registrationDate)],
            ['Selling Dealer', activeCustomerData?.sellingDealer],
            ['Responsible Dealer', activeCustomerData?.responsibleDealer],
            ['Model', machineDetails?.modelName],
            ['Description', machineDetails?.modelDescription],
            ['Model Year ', machineDetails?.modelYear],
            ['Latest Delivery Date', formatDateForExport(machineDetails?.deliveryReceiptDate)],
            ['Machine Build Date', formatDateForExport(machineDetails?.factoryBuildDate)],
            ['Last Reported Claim Measurement',],
            ['Last Reported Registration Measurement',machineDetails?.lastReportedMeasurement],
            ['',],
            ['Approximate Cumulative Rental Days',],
            ['JDLink Expiration Date',],
            ['Machine status 1', machineDetails?.newUsedIndicator === "N" ? "New" : "Used"],
            ['',],
            ['',]
        ];

        const warrantyCoverageHeaderData = [
            ['Warranty Coverage'],
            ['Warranty Type', 'Coverage Term', 'Expiration Date', 'Days Remaining (may be estimate)', 'Hours Limit', 'Deductible Amount']
        ];

        // Changes done to handle null for warrantyData
        const warrantyCoverageData =
            warrantyData && Array.isArray(warrantyData)
                ? warrantyData.map(({ warrantyTypeName, coverageTerm, expirationDate, daysRemaining, hoursLimit, deductibleCost }) => {
                    const parsedDate = parseISO(expirationDate);
                    const formattedDate = format(parsedDate, 'dd MMM yyyy');
                    return [warrantyTypeName, coverageTerm, formattedDate, daysRemaining, hoursLimit, deductibleCost];
                })
                : [];

        const cSNHeaderData = [
            ['Component Serial Numbers'],
            ['Component', 'Serial Number']
        ];

        const componentsListData =
            csnData?.components && Array.isArray(csnData.components)
                ? csnData.components.map((comp) => [comp.componentLongDescription, comp.serialNumbers[0]?.serialNumber])
                : [];

        const optionCodeHeaderData = [
            ['Order Base/Option Codes'],
          /*  ['Code', 'Component', 'Invoice / Transfer Date']*/
            ['Code', 'Component', 'Base Machine Code']

        ];
        const baseMachineCode = optionCodeData.productDetails.productCategories
            .find(category => category.categoryType === 'Base Machine Code')?.categoryName;

        const optionsList =
            optionCodeData?.productConfiguration?.options
                ? Object.values(optionCodeData.productConfiguration.options).map(option => [
                    option.categoryName,
                    option.categoryDescription,
                    baseMachineCode  // Include the base machine code here
                ])
                : [];

        const customerHistoryHeader = [
            ['Customer History']
        ];

        // Customer History Data is mapped to a List of List structure to add it as Excel rows.
        // We can also utilize it for the purpose of displaying the Active Customer Data in the Machine Details section
        const customerHistoryData = custHistoryData.map(
            (custData) => {
                const customer = custData?.customer;
                const indCustomerName = [customer?.firstName, customer?.middleName, customer?.lastName].map(name => name?.trim()).filter(Boolean).join(" ");
                const customerName = customer?.businessName1?.trim() || customer?.businessName2?.trim() || indCustomerName || "N/A";
                return [
                    [customerName],
                    [custData.customer?.addresses[0]?.street, custData.customer?.addresses[0]?.street2],
                    [custData.customer?.addresses[0]?.city + " " + custData.customer?.addresses[0]?.state + " " + custData.customer?.addresses[0]?.country],
                    [''],
                    ['Home', ((custData.customer?.homePhone?.countryCode || "") + (custData.customer?.homePhone?.areaCode || "") + (custData.customer?.homePhone?.phoneNumber || "")) || "N/A"],
                    ['Cell', ((custData.customer?.mobilePhone?.countryCode || "") + (custData.customer?.mobilePhone?.areaCode || "") + (custData.customer?.mobilePhone?.phoneNumber || "")) || "N/A"],
                    ['Business', ((custData.customer?.workPhone?.countryCode || "") + (custData.customer?.workPhone?.areaCode || "") + (custData.customer?.workPhone?.phoneNumber || "")) || "N/A"],
                    ['Customer Number', custData.customer?.entityId + ""],
                    ['Purchase Type', custData.purchaseType],
                    ['End Use Code', custData.endUseCodeDesc],
                    ['Delivery Date', formatDateForExport(custData.deliveryReceiptDate)],
                    ['Selling Dealer', custData.sellingDealer],
                    ['Responsible Dealer', custData.responsibleDealer],
                    ['']
                ]
            }
        );

        // Define the claim history header
        const claimHistoryHeader = [
            ['Claim History'],
            ['Dealer', 'Claim #', 'Type', 'Fail Date', 'Repair Date', 'Process Date', 'Ref # 1', 'Ref # 2', 'Measurement']
        ];

        const claimHistoryData = claimsData?.map(
            (claim) => {
                return [claim.dealer?.dealerNumber, claim.claimNumber, claim.claimType,
                    formatDateForExport(claim.failureDate), formatDateForExport(claim.repairDate), formatDateForExport(claim.processDate), claim.reference1, claim.reference2, claim.measurement]
            }
        );

        const pipHistoryHeader = [
            ['PIP History'],
            ['PIP Number', 'PIP Type', 'PIP Participation Type', 'PIP Title', 'PIP Status']
        ];

        const pipListData = pipsData.map(
            ({pipNumber, pipType, participant, pipTitle, status}) =>
            { return [pipNumber, pipType, participant, pipTitle, status] }
        );

        // Add data to the machine details sheet
        machineDetailsData.forEach((row, rowIndex) => {
            const cell = machineDetailsSheet.addRow(row);
            cell.getCell(1).style.font = {bold: true};

            if (rowIndex === 0) {
                machineDetailsSheet.mergeCells(`B${rowIndex + 1}:C${rowIndex + 1}`);
            } else if (rowIndex >= 2 && rowIndex <= 7) {
                machineDetailsSheet.mergeCells(`A${rowIndex + 1}:C${rowIndex + 1}`);
                cell.getCell(4).value = row[1];
            } else if (rowIndex => 9 && rowIndex <= 31) {
                machineDetailsSheet.mergeCells(`A${rowIndex + 1}:C${rowIndex + 1}`);
                cell.getCell(4).value = row[1];
            }

            //row index starts at 0 but the Excel is indexed starting at 1
            /*if (rowIndex >= 2 && rowIndex <= 7) {
                machineDetailsSheet.mergeCells(`A${rowIndex + 1}:C${rowIndex + 1}`);
            }*/
        });

        warrantyCoverageHeaderData.forEach((row) => {
            const cell = machineDetailsSheet.addRow(row);
            // Apply a style to the entire row
            cell.eachCell({includeEmpty: true}, (cell, colNumber) => {
                cell.style.font = {bold: true};
                cell.style.alignment = {horizontal: 'left'}; // You can adjust the alignment as needed
            });
        });

        warrantyCoverageData.forEach((row, rowIndex) => {
            const cell = machineDetailsSheet.addRow(row);
        })

        machineDetailsSheet.addRow('');

        cSNHeaderData.forEach((row) => {
            const cell = machineDetailsSheet.addRow(row);
            // Apply a style to the entire row
            cell.eachCell({includeEmpty: true}, (cell, colNumber) => {
                cell.style.font = {bold: true};
                cell.style.alignment = {horizontal: 'left'}; // You can adjust the alignment as needed
            });
        });

        componentsListData.forEach((row, rowIndex) => {
            const cell = machineDetailsSheet.addRow(row);
        })

        machineDetailsSheet.addRow('');

        optionCodeHeaderData.forEach((row) => {
            const cell = machineDetailsSheet.addRow(row);
            // Apply a style to the entire row
            cell.eachCell({includeEmpty: true}, (cell, colNumber) => {
                cell.style.font = {bold: true};
                cell.style.alignment = {horizontal: 'left'}; // You can adjust the alignment as needed
            });
        });

        optionsList.forEach((row, rowIndex) => {
            const cell = machineDetailsSheet.addRow(row);
        });

        machineDetailsSheet.addRow('');

        customerHistoryHeader.forEach((row) => {
            const cell = machineDetailsSheet.addRow(row);
            // Apply a style to the entire row
            cell.eachCell({includeEmpty: true}, (cell, colNumber) => {
                cell.style.font = {bold: true};
                cell.style.alignment = {horizontal: 'left'}; // You can adjust the alignment as needed
            });
        });

        customerHistoryData.forEach((customerDataArray) => {
            customerDataArray.forEach((row, rowIndex) => {
                machineDetailsSheet.addRow(row);
            });
        });

        machineDetailsSheet.addRow('');

        claimHistoryHeader.forEach((row) => {

            const cell = machineDetailsSheet.addRow(row);
            // Apply a style to the entire row
            cell.eachCell({includeEmpty: true}, (cell, colNumber) => {
                cell.style.font = {bold: true};
                cell.style.alignment = {horizontal: 'left'}; // You can adjust the alignment as needed
            });
        });

        claimHistoryData.forEach((row, rowIndex) => {
            const cell = machineDetailsSheet.addRow(row);
        })

        machineDetailsSheet.addRow('');

        pipHistoryHeader.forEach((row) => {
            const cell = machineDetailsSheet.addRow(row);
            // Apply a style to the entire row
            cell.eachCell({includeEmpty: true}, (cell, colNumber) => {
                cell.style.font = {bold: true};
                cell.style.alignment = {horizontal: 'left'}; // we can adjust the alignment as needed
            });
        });

        pipListData.forEach((row, rowIndex) => {
            const cell = machineDetailsSheet.addRow(row);
        });

        // Add data to the claim history sheet
        /*claimHistoryHeader.forEach((row) => {
            claimHistorySheet.addRow(row);
        });

        claimHistoryData.forEach((row) => {
            claimHistorySheet.addRow(row);
        });*/

        // Create a Blob to store the Excel file
        const blob = await workbook.xlsx.writeBuffer();

        // Create a download link and trigger the download
        const blobUrl = window.URL.createObjectURL(new Blob([blob]));
        const a = document.createElement('a');
        const pinNumber13 = (machineDetails && machineDetails.pinNumber13) ? machineDetails.pinNumber13.toUpperCase() : null;
        const pinNumber17 = (machineDetails && machineDetails.pinNumber17) ? machineDetails.pinNumber17.toUpperCase() : null;
        const ntvPin = (machineDetails && machineDetails.ntvPin) ? machineDetails.ntvPin.toUpperCase() : null;
        a.href = blobUrl;
        a.download = `${(pinNumber17 || ntvPin || pinNumber13)}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(blobUrl);
    }

    return (
        <Button variant="secondary" onClick={handleMachineDetailExport}>
            {translate('exportexcel', 'Export To Excel')}
        </Button>
    );
}

export default ExportMachineDetails;
